import { createSelector } from 'reselect'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { getCockpitUserAccess } from '../../lib/getCockpitUserAccess'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

const selectCockpitUserInfo = createSelector(
  [selectFinancialCockpitState],
  ({ userInfo }) => userInfo
)

export const selectCockpitUserAccess = createSelector(
  [selectCockpitUserInfo, selectUser],
  (userInfo, user) => getCockpitUserAccess(userInfo, user)
)
